import React from "react";
import { hostname, protocol } from "../../utils/config";
import { useDispatch } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import {
  AvatarBox,
  ConnectionsCardBox,
  ConnectionsCardCategory,
  ConnectionsCardChapter,
  ConnectionsCardContainer,
  ConnectionsCardDataBox,
  ConnectionsCardName,
  StyledAvatar,
} from "./ConnectionsCard.styles";

const ConnectionsCard = ({ cardData, isRef, refVal }) => {
  const dispatch = useDispatch();
  const {
    profileImage,
    name,
    profession,
    secondaryCategory,
    requiredSpeciality,
    chapterName,
    connectionUser,
  } = cardData;
  const handleConnectionDetailCard = () => {
    dispatch(dialogActions.setDialogType("myconnectiondetailcard"));
    dispatch(dialogActions.setRequestId(connectionUser));
    dispatch(dialogActions.setDataObj(cardData));
    return;
  };

  return (
    <ConnectionsCardContainer onClick={handleConnectionDetailCard}>
      <ConnectionsCardBox>
        <AvatarBox>
          <StyledAvatar
            alt={name}
            src={
              profileImage
                ? `${protocol}${hostname}:443//core-api/public/image/${profileImage}`
                : `${name}`
            }
          />
        </AvatarBox>

        <ConnectionsCardDataBox>
          <ConnectionsCardName title={`${name}`}>
            {`${name}`}
          </ConnectionsCardName>
          <ConnectionsCardCategory
            title={`${profession} | ${secondaryCategory}${requiredSpeciality ? ` | ${requiredSpeciality}` : ""}`}
          >
            {profession && secondaryCategory
              ? `${profession} | ${secondaryCategory}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
              : profession
              ? `${profession}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
              : secondaryCategory
              ? `${secondaryCategory}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
              : "\u00A0"}
          </ConnectionsCardCategory>

          {isRef ? (
            <ConnectionsCardChapter ref={refVal}>
              {`${chapterName ? chapterName : " "}`}
            </ConnectionsCardChapter>
          ) : (
            <ConnectionsCardChapter>
              {`${chapterName ? chapterName : " "}`}
            </ConnectionsCardChapter>
          )}
        </ConnectionsCardDataBox>
      </ConnectionsCardBox>
    </ConnectionsCardContainer>
  );
};

export default ConnectionsCard;
